import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'entity/list', method: 'POST', body: filter, token: token })
}
